import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  useTheme,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { DraftErrorInfo } from "../hooks/parsePromoteErrors";

interface DraftPromoteErrorDialogProps {
  error: DraftErrorInfo | null;
  onClose: () => void;
}

const DraftPromoteErrorDialog: React.FC<DraftPromoteErrorDialogProps> = ({
  error,
  onClose,
}) => {
  const { t } = useTranslation("catalog-v2");
  const theme = useTheme();
  const fieldErrors = error?.fields ?? [];

  return (
    <Dialog open={!!error} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ fontWeight: 700 }}>
        {t("promote-dialog.title")}
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ fontSize: "14px", mb: fieldErrors.length ? 2 : 0 }}>
          {t("promote-dialog.description")}
        </Typography>
        {fieldErrors.length > 0 ? (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
            {fieldErrors.map((fe, i) => (
              <Box key={`${fe.draftId ?? "x"}-${i}`}>
                {fe.draftId != null && (
                  <Typography sx={{ fontSize: "13px", fontWeight: 700 }}>
                    {t("promote-dialog.draft-label", { id: fe.draftId })}
                  </Typography>
                )}
                <Typography
                  sx={{
                    fontSize: "13px",
                    color: theme.palette.text.tertiary,
                  }}
                >
                  {fe.fields.join(", ")}
                </Typography>
              </Box>
            ))}
          </Box>
        ) : error?.message ? (
          <Typography
            sx={{ fontSize: "13px", color: theme.palette.text.tertiary }}
          >
            {error.message}
          </Typography>
        ) : null}
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{ textTransform: "none", borderRadius: "8px" }}
        >
          {t("promote-dialog.cancel")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DraftPromoteErrorDialog;
